import styled, { css } from 'styled-components';
import { devices } from '../../const/devices';

export const RelativeContainer = styled.div`
	position: relative;

	width: 120px;
	height: 120px;

	& > div {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
	}

	@media ${devices.tablet} {
		width: 100px;
		height: 100px;
	}
`;

export const Label = styled.p<{ $success?: boolean; $color?: string }>`
	font-size: 15px;
	font-weight: 600;

	color: #000;

	span {
		color: ${({ $color }) => $color || '#1677ff'};
	}

	${({ $success }) =>
		$success &&
		css`
			color: #000;

			span {
				color: #000;
			}
		`}

	@media ${devices.tablet} {
		font-size: 14px;
	}
`;
